// extracted by mini-css-extract-plugin
export default {"goBack":"GoBackButton_goBack__lXIT+","goBackArrow":"GoBackButton_goBackArrow__Lzumr"};